import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { config } from '../_helpers/global';
import { Report } from '../_models/report';
import { map } from 'rxjs/operators';

@Injectable()
export class ReportService {

  constructor(private http: HttpClient) { }

  sendReport(report: Report) {
    return this.http.post<any>(`${config.apiUrl}/mail`, report);
  }

}
